import './style.sass';

import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';

const rukamiResultsList = [
    'Интерактивная платформа, выдерживающая большую нагрузку;',
    '2 дня бесперебойной работы;',
    '220 онлайн-активностей;',
    '28-29 ноября платформу посетили 60 тысяч зрителей.',
];

const Results = () => {
    return (
        <ScrollAnimation
            className="rukami-results"
            animateIn="fadeIn"
            offset={100}
            animateOnce={true}
            duration={1}
        >
            <FullWrapper className="rukami-results__content" smallPaddings={true}>
                <CommonTitle>Результаты</CommonTitle>
                <div className="rukami-results__content">
                    <div className="rukami-results__list">
                        {rukamiResultsList.map(text => (
                            <div key={text} className="rukami-results__list-item">
                                {text}
                            </div>
                        ))}
                    </div>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Results;
